var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button',{attrs:{"disabled":(_vm.counting || _vm.sending || _vm.disabled),"loading":_vm.sending,"type":_vm.btnType},on:{"click":_vm.sendCode}},[_vm._v(_vm._s(_vm.content)+" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }